module.exports = "<main role=\"main\">\n  <div class=\"container\">\n\n    <div class=\"row\">\n      <div class=\"col-md-7 order-2\">\n        <h2 class=\"text-title\">Biografia</h2>\n        <p class=\"lead text-justify\" style=\"word-break:break-all\" [innerHTML]=\"(item | async)?.texto\"></p>\n      </div>\n      <div class=\"col-md-5 order-1\" *ngIf=\"item.foto\">\n        <img class=\"img-fluid mx-auto\" src=\"{{ (item | async)?.foto.url }}\">\n      </div>\n    </div>\n  </div>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bibliografia/bibliografia.component.html
// module id = ./src/app/bibliografia/bibliografia.component.html
// module chunks = main